import api from '../../common/api';

const initialState = () => ({
  allNews: [],
  unReadNews: [],
  currentReadNews: null,
  currentNews: {},
  filters: {
    allNews: {
      title: '',
      is_active: '',
      scope: '',
      created_at: '',
      notes: '',
    }
  },
  pagination: {
    allNews: {
      count: 0,
      page: 1,
      page_size: 10,
      total_page: 0,
      ordering: '',
    }
  },
  loadingNewsPage: false,
  stepCreatingNews: 0,
  queue: [],
  shownHistory: [],
  settings: {
    maxConcurrent: 1,
    showDelay: 300,
    autoCloseAfter: null
  }
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchAllNews({ commit, getters }) {
      try {
        commit('SET_LOADING', true);
        const params = getters.queryParams('allNews');
        const response = await api.get('/news/', {
          params
        });
        if (response && response?.length > 0) {
          commit('SET_ALL_NEWS', response);
        } else {
          commit('SET_ALL_NEWS', []);
        }
        return response;
      } catch (err) {
        return err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchAllUnReadNews({ commit, dispatch }) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get('/news/unread/', {
            params: {
              is_active: true,
            }
        });
        if (response && response?.length > 0) {
          commit('SET_ALL_UNREAD_NEWS', response);
          dispatch('showNextModal');
        }
        return response;
      } catch (err) {
        return err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchDetailNews({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.get(`/news/${payload.id}/`);
        if (response && response?.id) {
          if (!payload?.modal) {
            commit('SET_DETAIL_NEWS', response);
          }
          return { success: true, data: response };
        }
          return { success: false, data: { detail: 'По указаному ID овости не найдено' } };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createNews({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post('/news/', payload);
        commit('SET_STEP_CREATING', 1);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async updateNews({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.put(`/news/${payload.id}/`, payload);
        commit('SET_STEP_CREATING', 1);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async partiallyUpdateNews({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.patch(`/news/${payload.id}/`, payload);
        commit('SET_STEP_CREATING', 1);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createNewsImage({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/news/${payload.id}/upload-image/`, payload.formData);
        commit('SET_STEP_CREATING', 2);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteNews({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/news/${payload.id}/`);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async showNextModal({ state, commit, dispatch }) {
      if (state.unReadNews.length === 0) return;
      const nextModal = state.unReadNews[0];
      const res = await dispatch('fetchDetailNews', { modal: true, id: nextModal.id });
      if (res.success) {
        commit('SET_CURRENT_MODAL', res.data);
      }
    },
    async markModalAsRead({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/news/${payload.id}/mark-as-read/`);
        return { success: true, data: response };
      } catch (err) {
        return { success: false, data: err };
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Закрыть текущее окно
    async closeCurrentModal({ state, commit, dispatch }, { markAsRead = true } = {}) {
      if (!state.currentReadNews) return;

      const modalId = state.currentReadNews.id;

      if (markAsRead) {
        try {
           await dispatch('markModalAsRead', { id: modalId });
        } catch (error) {
          return { success: false, data: error };
        }
      }

      commit('REMOVE_FROM_QUEUE', modalId);
      commit('SET_CURRENT_MODAL', null);

      // Показываем следующую модалку с задержкой
      setTimeout(() => {
        dispatch('showNextModal');
      }, state.settings.showDelay);
    },

  },
  mutations: {
    SET_ALL_NEWS(state, news) {
      state.allNews = news;
    },
    SET_ALL_UNREAD_NEWS(state, news) {
      state.unReadNews = news.filter(news => news.is_active);
    },
    SET_LOADING(state, loading) {
      state.loadingNewsPage = loading;
    },
    SET_STEP_CREATING(state, stepCreating) {
      state.stepCreatingNews = stepCreating;
    },
    SET_PAGINATION(state, payload) {
      state.pagination[payload.name] = { ...payload };
    },
    SET_DETAIL_NEWS(state, payload) {
      state.currentNews = payload;
    },
    ADD_TO_QUEUE(state, modal) {
      state.unReadNews.push(modal);
    },
    REMOVE_FROM_QUEUE(state, modalId) {
      state.unReadNews = state.unReadNews.filter(m => m.id !== modalId);
    },
    NEXT_MODAL(state) {
      state.currentReadNews = state.queue[0] || null;
    },
    SET_CURRENT_MODAL(state, modal) {
      state.currentReadNews = modal;
    },
  },
  getters: {
    allNews: (state) => state.allNews,
    pagination: (state) => (field) => state.pagination[field],
    queryParams: (state) => (field) => {
      const params = { ...state.filters[field], ...state.pagination[field] };
      Object.keys(params).forEach(key => {
        const hiddenField = ['count', 'total_page', 'next', 'previous', 'totalPage'];
        if (params[key] === null || params[key] === '' || params[key] === undefined || hiddenField.includes(key)) {
          delete params[key];
        }
      });
      return params;
    },
    currentStepCreating: (state) => state.stepCreatingNews,
    currentNews: (state) => state.currentNews,
    currentReadNews: (state) => state.currentReadNews,
    unReadNews: (state) => state.unReadNews,
    hasUnreadModals: (state) => state.queue.length > 0,
    modalCount: (state) => state.queue.length,
    unshownModals: (state) => state.queue.filter(modal =>
        !state.shownHistory.includes(modal.id)
      ),
    isModalShown: state => (modalId) => (state).shownHistory.includes(modalId)
  },
};
